
/**
 *cookie
 */
export const cookie = {
    /*
    作用：通过传key值，返回需要的当前key的value值，即封装cookie的查
    参数：name->cookie中的key值
    返回：有则返回value，无则返回""空
    调用方法 console.log(getCookie("phone"));
    */
    get (name) {
        var cookieTxt = document.cookie;
        var arr = cookieTxt.split("; ");
        for(var i=0; i<arr.length; i++) {
            var arr1 = arr[i].split("=");
            if(decodeURIComponent(arr1[0]) == name) {
                return decodeURIComponent(arr1[1]);
            }
        }
        return "";
    },

    /*
    作用：封装cookie的增和改
    参数：name->当前这条cookie的名称，value->当前cookie的值，day->当前cookie存在的天数为0或为空则为有效时间是当前会话，path->为当前cookie的有效路径不设则为根路径/
    */
    set (name,value,day,path) {
        var result = "";
        result += encodeURIComponent(name)+"="+encodeURIComponent(value);
        if(day) {
            var date = new Date();
            date.setDate(date.getDate()+day);
            result += "; expires="+date;
        }
        if(path) {
            result += "; path="+path;
        } else {
            result += "; path=/";
        }
        document.cookie = result;
    },

    /*
    作用：封装cookie的删
    参数：name->需要删除的cookie的名称
    */
    remove (name) {
        this.set(name,"",-1);
    }
}

export const storage = {
    /**
     * 存储sessionStorage
     */
    set (name, data) {
        if (!name) return;
        if (typeof data !== 'string') {
            data = JSON.stringify(data);
        }
        window.sessionStorage.setItem(name, data);
    },

    /**
     * 获取sessionStorage
     */
    get (name) {
        if (!name) return;
        var value = window.sessionStorage.getItem(name);
        if (value !== null) {
            try {
                value = JSON.parse(value);
            } catch (e) {
                value = value;
            }
        }
        return value;
    },

    /**
     * 删除sessionStorage
     * name 为空时  清除所有数据
     */
    remove (name) {
        if (!name) {
            window.sessionStorage.clear();
        }else {
            window.sessionStorage.removeItem(name);
        }
    },
}


/**
 *正则格式验证
 *@param {String} type [需要验证的类型]
 *@param {String} val [验证的文本]
 *@return {Boolean} [true验证通过，false验证不通过]
 */
 export function verify (type, val) {
	var res = false;

	var reg = {
		tel: /^0[0-9]{2,3}-[0-9]{7,8}$/, // 座机号码
		// phone: /^(13[0-9]|15[012356789]|18[0-9]|17[678]|14[57])[0-9]{8}$/, // 手机号码
		phone: /^[1]([3-9])[0-9]{9}$/, //手机号码
		idcard: /\d{17}[\d|x]|\d{15}/, // 身份证号
		email:/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,//邮箱
		userName:/^[A-Za-z0-9]{1,8}$/,//用户名为数字和字母
		password:/^([A-Za-z\d]|[@\$!%\*#\?&\.]){6,10}$/,//密码为数字、字母、@$!%*#?&.
		space: /^[\s]*$/,//判断是否全部为空格
	}

	// 座机号码验证
	if (type == 'tel') {
		if (reg.tel.test(val)) {
			res = true;
		}
	}

	// 手机号码验证
	if (type == 'phone') {
		if (reg.phone.test(val)) {
			res = true;
		}
	}

	// 身份证验证
	if (type == 'idcard') {
		if (reg.idcard.test(val)) {
			res = true;
		}
	}
	// 邮箱验证
	if (type == 'email') {
		if (reg.email.test(val)) {
			res = true;
		}
	}
	//用户名
	if(type == 'userName'){
		if(reg.userName.test(val)){
			res=true;
		}
	}
	//密码
	if(type == 'password'){
		if(reg.password.test(val)){
			res=true;
		}
	}
	//空格
	if(type == 'space'){
		if(reg.space.test(val)){
			res=true;
		}
	}
	return res;
}


/**
 *判断是否为空
 *@return {Boolean} [true为空，false不为空]
 */
export function isEmpty (val) {
	return !val && val!==0 && typeof val!=="boolean"?true:false;
}

/**
 *格式化时间
 *@param {String} time [可以new Date()的时间]
 *@param {String} format [时间格式化类型
		yyyy			年
		M				月		不用补0
		MM				月		需要补0
		W 				周		不用补0
		WW				周		需要补0
		d 				日		不用补0
		dd				日		需要补0
		H 				24小时	不用补0
		HH 				24小时	需要补0
		h 				12小时	不用补0
		hh 				12小时	需要补0
		m 				分		不用补0
		mm 				分		需要补0
		s 				秒		不用补0
		ss 				秒		需要补0
		timestamp 		时间戳   
		
		例子：yyyy年MM月dd日 HH:mm:ss
 	]
 */
export function switchTime (time, format) {
	format = format ? format : 'yyy年MM月dd日 HH:mm:ss';

	var res = format;

	var date = new Date(time);
	var timestamp = date.getTime(),
		year = date.getFullYear(),
		month = date.getMonth() + 1,
		day = date.getDate(),
		hours = date.getHours(),
		minutes = date.getMinutes(),
		seconds = date.getSeconds(),
		week = date.getDay(); // 0是星期日

	// 判断传入是否可以转换为时间
	if (!year) {
		return time;
	}

	// 替换时间戳
	res = res.replace(/timestamp/g, timestamp);

	// 替换年
	res = res.replace(/yyyy/g, year);

	// 替换月
	res = res.replace(/MM/g, makeUpNum(month));
	res = res.replace(/M/g, month);

	// 替换日
	res = res.replace(/dd/g, makeUpNum(day));
	res = res.replace(/d/g, day);

	// 替换时
	res = res.replace(/HH/g, makeUpNum(hours));
	res = res.replace(/H/g, hours);

	// 替换分
	res = res.replace(/mm/g, makeUpNum(minutes));
	res = res.replace(/m/g, minutes);

	// 替换秒
	res = res.replace(/ss/g, makeUpNum(seconds));
	res = res.replace(/s/g, seconds);

	// 替换周
	res = res.replace(/WW/g, makeUpNum(week));
	res = res.replace(/W/g, week);

	return res;
}

/**
 *数字补0
 @param {Number} val [需要补0的数]
 */
export function makeUpNum (val) {
	return val < 10 ? '0' + parseInt(val) : val;
}


/**
 *@获取路由search参数
 */
export function getUrlSearch () {
	var res = {};
	try {
		var search = location.search.split('?')[1];

		search = search.split('&');
		for (var i = 0; i < search.length; i++) {
			var arr = search[i].split('=');
			res[arr[0]] = arr[1];
		}
	} catch (e) {
		res = {}
	}
	return res;
}


// dom样式属性
export var domStyle = {
	get: function (obj, name) {
	    if(window.getComputedStyle) {
	        return getComputedStyle(obj, null)[name];
	    } else {
	        return obj.currentStyle[name];
	    }
	},
	set: function  (obj, oStyle) {
	    for(var i in oStyle) {
	        obj.style[i] = oStyle[i];
	    }
	}
}

// 生成唯一id prefix前缀
export function createPrivateId (prefix) {
	var id = prefix + '_' + parseInt(Math.random() * 10000);
	var oDom = document.getElementById(id);
	if (oDom) {
		id += 1;
	}
	return id;
}
//除去富文本标签
export function removeRichTextLabel(text){
	var t = text.replace(/<[^<>]+>/g,'').replace(/&nbsp;/ig,'');
	t=t.substring(0,320);
	return t;

}

export function hiddenPhone(value){
	var pat=/(\d{3})\d*(\d{4})/;
	var b=value.replace(pat,'$1****$2');
	return b;
}
import {Message} from 'element-ui';
export function isLogin(){
	var name=cookie.get('userRealName');
	if(name==''||name==null){
		Message.warning("请登录");
		return false;
	}else{
		return true;
	}
};
export default {
	cookie,				// cookie
	storage,			// sessionStorage
	verify,				// 正则验证
	isEmpty,			// 是否为空
	switchTime,			// 格式化时间
	makeUpNum,			// 数字补0
	getUrlSearch,		// 获取路由search参数
	isLogin,			//判断是否登录
	removeRichTextLabel,//除去富文本标签
	hiddenPhone,		//手机号脱敏
	domStyle,			// dom样式
}